import { render, staticRenderFns } from "./CopyrightTab.vue?vue&type=template&id=7f100dba&scoped=true&"
import script from "./CopyrightTab.vue?vue&type=script&lang=js&"
export * from "./CopyrightTab.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightTab.vue?vue&type=style&index=0&id=7f100dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f100dba",
  null
  
)

export default component.exports